// extracted by mini-css-extract-plugin
module.exports = {"root":"StockAvailable_root__3GCTl","table":"StockAvailable_table__2XIiq"};